<div class="flex-container">
  <div nz-col nzSpan="6" class="page-content--left">
    <form class="filter-form" nz-form (ngSubmit)="search()">
      <div class="filter-form__header sticky">
        <button class="button float-left" nz-button nzType="secondary" type="button" (click)="emptyFilter()">
          {{ 'integration.doc-01.filter.reset' | translate }}
        </button>
        <button class="button float-right" nz-button nzType="primary" [disabled]="loading || !patient" type="submit">
          {{ 'integration.doc-01.filter.search' | translate }}
        </button>
      </div>
      <div class="filter-form__body">
        <hw-panel-form-item label="integration.doc-01.filter.from">
          <hw-date-picker name="from" [(ngModel)]="params.from"></hw-date-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.doc-01.filter.to">
          <hw-date-picker name="to" [(ngModel)]="params.to"></hw-date-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.doc-01.filter.patient" [required]="true">
          <hw-patient-drawer-search
            (onSelect)="onPatientSelected($event)"
            [patientName]="patient?.defaultName?.text"></hw-patient-drawer-search>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.doc-01.filter.document-type">
          <hw-term-codesystem-concept-select
            [display]="typeTitle"
            [sort]="typeOrder"
            name="document-type"
            [codesystem]="'document-type'"
            [(ngModel)]="params.type">
          </hw-term-codesystem-concept-select>
        </hw-panel-form-item>
      </div>
    </form>
  </div>
  <nz-content class="page-content--header-inside" nz-col nzSpan="18">
    <hw-page-header header="integration.doc-01.data.title" class="page-header"></hw-page-header>
    <div class="page-content__flex-cols-container">
      <hw-spinner verticalPosition="middle" *ngIf="loading" [loading]="loading"></hw-spinner>
      <hw-table class="table-no-header" *ngIf="!loading" nz-col nzSpan="24">
        <nz-table
          #nzTable
          [nzData]="documents"
          [nzTotal]="total"
          [nzPageSize]="itemsPerPage"
          [nzPageIndex]="pageIndex"
          nzSize="small"
          [nzShowPagination]="true"
          [nzFrontPagination]="false"
          (nzPageIndexChange)="onPageIndexChange($event)"
          nzHideOnSinglePage="true"
          nzShowSizeChanger="false">
          <thead>
            <tr>
              <th>{{ 'integration.doc-01.data.document' | translate }}</th>
              <th>{{ 'integration.doc-01.data.version' | translate }}</th>
              <th>{{ 'integration.doc-01.data.type' | translate }}</th>
              <th>{{ 'integration.doc-01.data.creation-time' | translate }}</th>
              <th>{{ 'integration.doc-01.data.author' | translate }}</th>
              <th>{{ 'integration.doc-01.data.author-organization' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-template ngFor let-document [ngForOf]="nzTable.data">
              <tr>
                <td>
                  <a (click)="openDocument(document)">{{ document.identifier.value }}</a>
                </td>
                <td>{{ document.version }}</td>
                <td>{{ documentTypes[document.type]?.names | localName }}</td>
                <td>{{ document.createdAt | localDate }}</td>
                <td>{{ document.author?.familyName + ', ' + document.author?.givenName }}</td>
                <td>{{ document.organization?.name }}</td>
              </tr>
            </ng-template>
          </tbody>
        </nz-table>
      </hw-table>
    </div>
  </nz-content>
</div>
